import React from 'react';
import { 
  Palette, 
  BookOpen, 
  Droplets, 
  Lock, 
  Unlock,
  CheckCircle,
  Video
} from 'lucide-react';

const StatsGrid = ({ activeTab, stats, trainings = [] }) => {
  // Функция для определения цвета градиента в зависимости от типа
  const getGradient = (type) => {
    const gradients = {
      purple: 'from-purple-900/30 to-purple-900/10',
      blue: 'from-blue-900/30 to-blue-900/10',
      indigo: 'from-indigo-900/30 to-indigo-900/10',
      green: 'from-green-900/30 to-green-900/10',
      yellow: 'from-yellow-900/30 to-yellow-900/10',
      emerald: 'from-emerald-900/30 to-emerald-900/10',
      cyan: 'from-cyan-900/30 to-cyan-900/10'
    };
    return gradients[type] || gradients.purple;
  };

  // Рендер одного блока статистики
  const StatBlock = ({ value, label, icon: Icon, gradient = 'purple', compact = false }) => (
    <div className={`bg-gradient-to-br ${getGradient(gradient)} rounded-xl p-3 border border-white/5 hover:border-white/10 transition-all`}>
      <div className="flex items-start justify-between">
        <div>
          <div className="text-xl font-bold">{value}</div>
          <div className="text-gray-400 text-xs flex items-center mt-0.5">
            <Icon className="w-3 h-3 mr-1" />
            <span className="truncate max-w-[100px]">{label}</span>
          </div>
        </div>
      </div>
    </div>
  );

  // Блоки для уроков
  const lessonBlocks = [
    { value: stats.totalLessons, label: 'Всего уроков', icon: BookOpen, gradient: 'purple' },
    { value: stats.acryl || 0, label: 'Акрил', icon: Palette, gradient: 'purple' },
    { value: stats.watercolor || 0, label: 'Акварель', icon: Droplets, gradient: 'blue' },
    { value: stats.video || 0, label: 'Видео', icon: Video, gradient: 'indigo' },
    { value: stats.freeLessons || 0, label: 'Бесплатно', icon: Unlock, gradient: 'green' },
    { value: stats.premiumLessons || 0, label: 'Премиум', icon: Lock, gradient: 'yellow' },
    { value: stats.totalFiles || 0, label: 'Всего файлов', icon: BookOpen, gradient: 'blue' },
    { value: stats.lessonsWithFiles || 0, label: 'С файлами', icon: CheckCircle, gradient: 'emerald' }
  ];

  // Блоки для тренингов
  const trainingBlocks = [
    { value: stats.totalTrainings, label: 'Всего тренингов', icon: BookOpen, gradient: 'purple' },
    { value: stats.acrylTrainings || 0, label: 'Акрил', icon: Palette, gradient: 'purple' },
    { value: stats.watercolorTrainings || 0, label: 'Акварель', icon: Droplets, gradient: 'blue' },
    { value: stats.videoTrainings || 0, label: 'Видео', icon: Video, gradient: 'indigo' },
    { value: stats.trainingsWithLessons || 0, label: 'С уроками', icon: CheckCircle, gradient: 'green' },
    { value: stats.premiumTrainings || 0, label: 'Премиум', icon: Lock, gradient: 'yellow' },
    { value: trainings.filter(t => t.files && t.files.length > 0).length || 0, label: 'С файлами', icon: CheckCircle, gradient: 'emerald' },
    { value: stats.trainingLessons || 0, label: 'Уроков в тренингах', icon: BookOpen, gradient: 'cyan' }
  ];

  // Блоки для аудио
  const audioBlocks = [
    { value: stats.totalAudioLessons || 0, label: 'Всего аудио', icon: BookOpen, gradient: 'emerald' },
    { value: stats.totalAudioFiles || 0, label: 'Аудио файлов', icon: Video, gradient: 'purple' },
    { value: stats.freeAudioLessons || 0, label: 'Бесплатно', icon: Unlock, gradient: 'green' },
    { value: stats.premiumAudioLessons || 0, label: 'Премиум', icon: Lock, gradient: 'yellow' }
  ];

  // Выбираем блоки в зависимости от активной вкладки
  const getBlocks = () => {
    switch(activeTab) {
      case 'lessons':
        return lessonBlocks;
      case 'trainings':
        return trainingBlocks;
      case 'audio':
        return audioBlocks;
      default:
        return [];
    }
  };

  const blocks = getBlocks();

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-2 mb-6">
      {blocks.map((block, index) => (
        <StatBlock
          key={index}
          value={block.value}
          label={block.label}
          icon={block.icon}
          gradient={block.gradient}
        />
      ))}
    </div>
  );
};

export default StatsGrid;